import React from 'react';
import { Columns2, Grid3x3, Rows3 } from 'lucide-react';

/**
 * How the activity results are laid out: one wide row per trip, two big cards across, or
 * three across. Two across is the default; the choice is remembered (see useActivityView).
 * Mobile is always a single column whatever is picked here.
 */
const OPTIONS = [
  { mode: 'list', label: 'List', Icon: Rows3 },
  { mode: 'grid2', label: '2 Col', Icon: Columns2 },
  { mode: 'grid3', label: '3 Col', Icon: Grid3x3 },
];

const ActivityViewToggle = ({ view, onChange }) => (
  <div className="flex items-center gap-1 rounded-md border border-gray-200 bg-gray-100 p-0.5" data-testid="activity-view-toggle">
    {OPTIONS.map(({ mode, label, Icon }) => {
      const active = view === mode;
      return (
        <button
          key={mode}
          type="button"
          onClick={() => onChange(mode)}
          aria-pressed={active}
          title={`${label} view`}
          className={`flex items-center gap-1.5 rounded px-2.5 py-1.5 text-xs font-bold uppercase tracking-wide transition-colors ${
            active ? 'bg-blue-800 text-white shadow-sm' : 'text-slate-600 hover:bg-white hover:text-slate-900'
          }`}
          data-testid={`activity-view-toggle-${mode}`}
        >
          <Icon className="h-3.5 w-3.5" /> <span className="hidden sm:inline">{label}</span>
        </button>
      );
    })}
  </div>
);

export default ActivityViewToggle;
